/**
 * Public Header Component
 * Header for public-facing pages (HomePage)
 */

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const PublicHeader = () => {
  const navigate = useNavigate();
  const [loopText, setLoopText] = useState('...Hello Reader...');

  const texts = [
    'கலை என்பது நொறுங்கிப்போன மனிதர்களுக்கான ஆறுதல் கருவிகள்.(-வின்சென்ட் வான் கோ)',
    'ஒரே ஒரு கவிதை போதும் இந்த ஜென்மம் பொருள்பட என்பது என் நம்பிக்கை அதை எழுதிவிடக் காத்துக் கொண்டிருக்கிறேன்.(-சுந்தர ராமசாமி)',
    'முடிந்துவிட்டது என்று தீர்மானித்தவனின் பாதையில் தினமும் நிகழ்ந்துக்கொண்டிருக்கிறது விடியல். (-கலாப்ரியா)',
    'தேவைகள் ஒவ்வொரு உயிருக்குள்ளும் மூர்க்கமாய் இருக்கிறது.(-குட்டி ரேவதி)',
    'ஒவ்வொரு சாயலுடன் யாரிடமாவது யாரையாவது தேடுகிறோம்.யாரையாவது யாரிடமாவது அடைந்தும் விடுகிறோம்.(-வண்ணதாசன்)',
    'நான் எதையாவது எழுதலாம் எனில் பாரபட்சமின்றி எல்லாவற்றையும் நேசிக்க வேண்டும்.அந்த நேசத்தின் வழியாக என் எழுத்து உருவாக வேண்டும். (-இவான் துர்கேனிவ்)',
    'குடைக்காளான் குழம்பு சமைக்கும் நாட்களில் மழை வரவேண்டுமென்று அவள் அடம்பிடிக்கும் கோரிக்கையை ஒரு கணவனாக இருந்து உன்னால் நிறைவேற்றக் கூடாமல் போனால் அன்று மட்டுமேனும் ஒரு கடவுளாய் இருந்து பாரேன்.(-ஜெ.பிரான்சிஸ் கிருபா)',
    'மனிதனாகும் முயற்சியில் கவிஞனாகிவிட்டான் பாவம்.அவனால் இனி எப்போதும் மனிதனாக முடியாது. (-கார்த்திக் நேத்தா)',
    'துச்சம் என உதிர்க்கப்பட்ட சுள்ளிகளால்தான் ஒரு பறவை தன் கூட்டை கட்டிக் கொள்கிறது.(-நேசமித்ரன்)'
  ];

  useEffect(() => {
    let index = 0;
    const animateText = () => {
      setLoopText(texts[index]);
      index = (index + 1) % texts.length;
    };

    const timer = setInterval(animateText, 7000);
    const initialTimer = setTimeout(animateText, 1500);

    return () => {
      clearInterval(timer);
      clearTimeout(initialTimer);
    };
  }, []);

  const openEbookPage = (event) => {
    event.preventDefault();
    navigate('/');
    setTimeout(() => {
      const element = document.getElementById('ebook');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 50);
  };

  return (
    <header>
      <div className="header-left">
        <p>
          <a href="https://siragupathippagam.in/blog">Blogs</a>
        </p>
        <button className="brown-shine-btn" onClick={openEbookPage}>
          அகை இலக்கிய இதழ்
        </button>
      </div>

      <div className="header-center">
        <div className="loop-text">{loopText}</div>
      </div>

      <div className="header-right">
        <h2>Siragu Pathippagam</h2>
        <p>சிறகு பதிப்பகம்</p>
      </div>
    </header>
  );
};

export default PublicHeader;
